/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Analysis } from '../model/models';
import { AnalysisHeader } from '../model/models';
import { AnalysisProcedureResponse } from '../model/models';
import { GetFilteredAnalysisByPreFilteredDataRequest } from '../model/models';
import { TableSort } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface AnalysisServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get analysis header by analyticProcessId
     * This endpoint returns all the needed information for the provided analyticProcessId. It provides the analysis header data. 
     * @param analyticProcessId ID of the analytic process
     */
    getAnalysisHeader(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<AnalysisHeader>>;

    /**
     * Retrieve a list of Analysis objects by analysisProcessId
     * This endpoint is used to retrieve a list of Analysis objects based on the provided analysisProcessId. The Analysis objects are displayed in the UI. 
     * @param analyticProcessId ID of the analytic process
     */
    getAnalysisListByProcessId(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<Analysis>>;

    /**
     * Get filtered analytic data by analyticProcessId
     * This endpoint returns filtered analytic data based on the provided analyticProcessId. The filters applied for this endpoint are the default filters. 
     * @param analyticProcessId ID of the analytic process
     */
    getAnalyticFilterDefault(analyticProcessId: number, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Returns all filtered analytic data
     * Returns all filtered analytic data depending on their filter
     * @param analyticProcessId ID of the analytic process
     * @param requestBody 
     */
    getFilteredAnalysis(analyticProcessId: number, requestBody?: { [key: string]: any; }, extraHttpRequestParams?: any): Observable<Array<Analysis>>;

    /**
     * Get filtered analytic data by default filter
     * This endpoint returns all filtered analytic data based on the default filter for the provided analyticProcessId. The default filter is applied when no specific filter is provided. 
     * @param analyticProcessId ID of the analytic process
     */
    getFilteredAnalysisByDefaultValue(analyticProcessId: number, extraHttpRequestParams?: any): Observable<Array<Analysis>>;

    /**
     * Returns filtered analytic data based on pre-filtered data
     * Returns filtered analytic data based on pre-filtered data identified by the analyticProcessId, analyticFilterDefinitionId and structureIds
     * @param analyticProcessId ID of the analytic process
     * @param analyticFilterDefinitionId ID of the analytic filter definition
     * @param getFilteredAnalysisByPreFilteredDataRequest 
     */
    getFilteredAnalysisByPreFilteredData(analyticProcessId: number, analyticFilterDefinitionId: number, getFilteredAnalysisByPreFilteredDataRequest: GetFilteredAnalysisByPreFilteredDataRequest, extraHttpRequestParams?: any): Observable<Array<Analysis>>;

    /**
     * Get filtered analytic data by procedure
     * This endpoint returns a list of Analysis objects based on the provided procedure and filter parameters. It filters the analytic data based on the specified procedure and returns the response in the form of AnalysisProcedureResponse. 
     * @param procedureName Name of the database procedure
     * @param analyticProcessId ID of the analytic process
     * @param requestBody 
     */
    getFilteredAnalysisByProcedure(procedureName: string, analyticProcessId: number, requestBody?: { [key: string]: any; }, extraHttpRequestParams?: any): Observable<AnalysisProcedureResponse>;

    /**
     * Get Table Sort
     * Returns the standard sort and the selected sort for the table.
     */
    getTableSort(extraHttpRequestParams?: any): Observable<Array<TableSort>>;

}
